import IMask from "imask"

export default class Input {

  constructor (el) {
    this.el = el
    this.input = this.el.querySelector('input')
    this.im = null
  }

  init () {
    this.initEvents()
    
    if (this.input.value) {
      this.el.classList.add('focus')
    }
  }

  initEvents () {
    this.input.addEventListener('focus', () => this.onFocus())
    this.input.addEventListener('blur', () => this.onBlur())
  }

  onFocus () {
    this.el.classList.add('focus')
    if (this.input.getAttribute('type') === 'tel') {
      this.im = IMask(this.input, {
        mask: '+{38}(000)000-00-00',
        lazy: false
      });
    }
  }

  onBlur () {
    if (this.input.value === '') {
      this.el.classList.remove('focus')
    }
  }

}
